var Vue = require('vue')

const msgbox = {
  install(Vue, options) {
    Vue.prototype.$makeMsgBox = function (message = ' ', title = ' ', callback, ...args) {
      this.$bvModal.msgBoxConfirm(message, {
        title: title,
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            try {
              callback(...args);
            } catch (e) {
              console.error(
                "Não foi possivel executar a função de callback do $makeMsgBox. " +
                e
              );
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    };
  }
};

export default msgbox;



// WEBPACK FOOTER //
// ./src/utils/msgBox.js